(() => {
  const DW_FU_DIMENSIONS = Object.freeze({
    cleaning: {
      label: "Reinigungsöffnung",
      effectiveHeightMm: 500,
      source: "Jeremias DW-FU Bauteilzeichnung DW10, Seite 8",
    },
    connector: {
      label: "Feuerstättenanschluss 90°",
      effectiveHeightMm: 500,
      source: "Jeremias DW-FU Bauteilzeichnung DW317, Seite 12",
    },
    length_1000: {
      label: "Längenelement 1000 mm",
      effectiveHeightMm: 940,
      source: "Jeremias DW-FU Bauteilzeichnung DW13, Seite 13",
    },
    length_500: {
      label: "Längenelement 500 mm",
      effectiveHeightMm: 440,
      source: "Jeremias DW-FU Bauteilzeichnung DW14, Seite 13",
    },
    length_250: {
      label: "Längenelement 250 mm",
      effectiveHeightMm: 188,
      source: "Jeremias DW-FU Bauteilzeichnung DW15, Seite 14",
    },
    top_standard: {
      label: "Mündungsabschluss",
      effectiveHeightMm: 135,
      source: "Jeremias DW-FU Bauteilzeichnung DW32, Seite 28",
    },
    top_rain: {
      label: "Regenhaube mit Abschluss",
      effectiveHeightMm: 135,
      source: "Jeremias DW1076-B; Mündungshöhe wie DW32",
    },
  });

  const TECHNICAL_DIMENSIONS = Object.freeze({
    dw_fu: DW_FU_DIMENSIONS,
    dw_eco_2: {
      cleaning: {
        label: "Reinigungsöffnung",
        effectiveHeightMm: { 130: 120, 150: 140, 180: 150, 200: 190 },
        source: "Jeremias DW ECO 2.0 Bauteilzeichnung DWETN10, Seite 10; Gesamtmaß A abzüglich 60 mm Steckmaß",
      },
      connector: {
        label: "Feuerstättenanschluss 90°",
        effectiveHeightMm: { 130: 296, 150: 316, 180: 346, 200: 366 },
        source: "Jeremias DW ECO 2.0 Bauteilzeichnung DWETN11, Seite 11; wirksames Maß B",
      },
      length_1000: { label: "Längenelement 1000 mm", effectiveHeightMm: 940, source: "Jeremias DW ECO 2.0 Bauteilzeichnung DWETN13, Seite 12" },
      length_500: { label: "Längenelement 500 mm", effectiveHeightMm: 440, source: "Jeremias DW ECO 2.0 Bauteilzeichnung DWETN14, Seite 12" },
      length_250: { label: "Längenelement 250 mm", effectiveHeightMm: 190, source: "Jeremias DW ECO 2.0 Bauteilzeichnung DWETN15, Seite 12" },
      top_standard: { label: "Mündungsabschluss", effectiveHeightMm: 135, source: "PROJECT_APPROVED_DIMENSION_ASSUMPTION · DWETN32 · 2026-09-09" },
      top_rain: { label: "Regenhaube mit Abschluss", effectiveHeightMm: 135, source: "PROJECT_APPROVED_DIMENSION_ASSUMPTION · DWETN32 · 2026-09-09" },
    },
    dw_silver: {
      cleaning: { label: "Reinigungsöffnung", effectiveHeightMm: 500, source: "PROJECT_APPROVED_DIMENSION_ASSUMPTION · inherited from DW-FU · 2026-09-09" },
      connector: { label: "Feuerstättenanschluss 87°", effectiveHeightMm: 500, source: "PROJECT_APPROVED_DIMENSION_ASSUMPTION · 301-DW11 · 2026-09-09" },
      length_1000: { label: "Längenelement 1000 mm", effectiveHeightMm: 940, source: "PROJECT_APPROVED_DIMENSION_ASSUMPTION · 301-DW13 · 2026-09-09" },
      length_500: { label: "Längenelement 500 mm", effectiveHeightMm: 440, source: "PROJECT_APPROVED_DIMENSION_ASSUMPTION · 301-DW14 · 2026-09-09" },
      length_250: { label: "Längenelement 250 mm", effectiveHeightMm: 188, source: "PROJECT_APPROVED_DIMENSION_ASSUMPTION · 301-DW15 · 2026-09-09" },
      top_standard: { label: "Mündungsabschluss", effectiveHeightMm: 135, source: "PROJECT_APPROVED_DIMENSION_ASSUMPTION · 301-DW32 · 2026-09-09" },
      top_rain: { label: "Regenhaube", effectiveHeightMm: 0, source: "Separates Zubehör oberhalb 301-DW32; nicht höhenrelevant" },
    },
  });

  const money = (cents, format) => {
    const value = (cents / 100).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return (format || "{{ amount_with_comma_separator }} €").replace(
      /\{\{\s*(?:amount|amount_with_comma_separator)\s*\}\}/,
      value,
    );
  };

  const diameterOf = (variant) => {
    const source = [variant.title, ...(variant.options || [])].join(" ");
    return (
      (source.match(/(?:Ø|ø)?\s*(130|150|180|200)\s*mm/i) || [])[1] || null
    );
  };

  const variantFor = (product, diameter) =>
    product?.variants?.find((variant) => diameterOf(variant) === diameter) ||
    null;

  const roofSlopeOf = (variant) =>
    (variant.options || []).find(
      (option) => !/(?:Ø|ø)?\s*(?:130|150|180|200)\s*mm/i.test(option),
    ) || null;

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = "true";
    const config = JSON.parse(
      root.querySelector("[data-config-data]").textContent,
    );
    let systemKey = root.querySelector('[name="system"]:checked')?.value || "dw_fu";
    let systemConfig = config.systems?.[systemKey] || config.systems?.dw_fu || {};
    let products = systemConfig.productsSource === "settings" ? config.products : (systemConfig.products || {});
    let technicalDimensions = TECHNICAL_DIMENSIONS[systemKey] || {};
    const form = root.querySelector(".msp-chimney-config__form");
    const content = root.querySelector("[data-config-content]");
    const toggle = root.querySelector("[data-config-toggle]");
    const progress = root.querySelector("[data-config-progress]");
    const optionalOptions = root.querySelector("[data-config-options]");
    const diameter = root.querySelector('[data-field="diameter"]');
    const height = root.querySelector('[data-field="height"]');
    const holder = root.querySelector('[data-field="holder"]');
    const holderQuantity = root.querySelector('[data-field="holder_quantity"]');
    const wallThickness = root.querySelector('[data-field="wall_thickness"]');
    const wallOptions = root.querySelector("[data-wall-options]");
    const wallError = root.querySelector("[data-wall-error]");
    const roofing = root.querySelector('[data-field="roofing"]');
    const roofSlope = root.querySelector('[data-field="roof_slope"]');
    const roofOptions = root.querySelector("[data-roof-options]");
    const offset = root.querySelector('[data-field="offset"]');
    const offsetAngle = root.querySelector('[data-field="offset_angle"]');
    const offsetQuantity = root.querySelector('[data-field="offset_quantity"]');
    const brace = root.querySelector('[data-field="brace"]');
    const offsetOptions = root.querySelector("[data-offset-options]");
    const facts = root.querySelector("[data-summary-facts]");
    const total = root.querySelector("[data-summary-total]");
    const status = root.querySelector("[data-summary-status]");
    const cart = root.querySelector("[data-config-cart]");
    const originalComponents = root.querySelector("[data-original-components]");
    const originalComponentsIntro = root.querySelector("[data-original-components-intro]");
    const compatibilityNote = root.querySelector("[data-system-compatibility-note]");
    const sketchCaption = root.querySelector("[data-sketch-caption]");
    const sketchLayers = [
      ...root.querySelectorAll('[data-sketch-layer]:not([data-sketch-layer="diagram"])'),
    ];
    const connectorQuantity = root.querySelectorAll(
      '[name="connector_quantity"]',
    );
    const steps = [...form.querySelectorAll("fieldset")];
    const completedSteps = new Set();
    let openStep = -1;
    let cartItems = [];
    let adding = false;
    let hasOpened = false;

    const stepValue = (fieldset) => {
      const checked = fieldset.querySelector("input:checked");
      if (checked) {
        return checked.closest("label")?.querySelector("strong")?.textContent.trim() || checked.value;
      }
      const select = fieldset.querySelector("select");
      if (select) return select.selectedOptions[0]?.textContent.trim() || "–";
      const number = fieldset.querySelector('input[type="number"]');
      if (number) return number.value ? `${number.value} ${number.nextElementSibling?.textContent || ""}`.trim() : "–";
      const toggle = fieldset.querySelector('input[type="checkbox"]');
      return toggle?.checked ? "Ja" : "Nein";
    };

    const updateAccordion = () => {
      steps.forEach((fieldset, index) => {
        const legend = fieldset.querySelector("legend");
        if (!legend) return;
        let summary = legend.querySelector("[data-step-summary]");
        if (!summary) {
          summary = document.createElement("span");
          summary.dataset.stepSummary = "true";
          legend.append(summary);
        }
        summary.textContent = completedSteps.has(index) ? stepValue(fieldset) : "";
        fieldset.classList.toggle("is-open", openStep === index);
        fieldset.classList.toggle("is-complete", completedSteps.has(index));
        legend.setAttribute("role", "button");
        legend.setAttribute("tabindex", "0");
        legend.setAttribute("aria-expanded", String(openStep === index));
      });
      progress.textContent = `${completedSteps.size} von ${steps.length} Angaben abgeschlossen`;
    };

    const openAccordionStep = (index) => {
      openStep = index < 0 ? -1 : Math.min(index, steps.length - 1);
      if (openStep >= 0 && steps[openStep]?.closest("[data-config-options]")) {
        optionalOptions.open = true;
      }
      updateAccordion();
    };

    const isStepValid = (fieldset, index) => {
      const selectedRadio = fieldset.querySelector('input[type="radio"]:checked');
      const selectedValue = selectedRadio?.value;
      if ([0, 3, 4, 5, 6, 8, 11].includes(index) && !selectedRadio) return false;
      if (index === 1) return Boolean(diameter.value);
      if (index === 2) return height.checkValidity() && Number(height.value) > 0;
      if (index === 6 && selectedValue === "with") {
        return wallThickness.checkValidity() && Number(wallThickness.value) > 0 && wallError.hidden;
      }
      if (index === 7) {
        return Boolean(holder.value) && holderQuantity.checkValidity() && Number(holderQuantity.value) > 0;
      }
      if (index === 8 && selectedValue === "with") {
        return Boolean(roofing.value) && Boolean(roofSlope.value);
      }
      if (index === 9 && offset.checked) {
        return Boolean(offsetAngle.value) && offsetQuantity.checkValidity() && Number(offsetQuantity.value) > 0;
      }
      return true;
    };

    const syncStepValidity = () => {
      steps.forEach((fieldset, index) => {
        if (isStepValid(fieldset, index)) completedSteps.add(index);
        else completedSteps.delete(index);
      });
      updateAccordion();
    };

    const setConfiguratorOpen = (isOpen) => {
      if (isOpen) hasOpened = true;
      content.hidden = !isOpen;
      toggle.setAttribute("aria-expanded", String(isOpen));
      toggle.textContent = isOpen
        ? "Konfigurator schließen"
        : hasOpened
          ? "Konfiguration fortsetzen"
          : "Konfigurator öffnen";
      root.classList.toggle("is-expanded", isOpen);
    };

    toggle.addEventListener("click", () => {
      setConfiguratorOpen(content.hidden);
    });

    document.querySelectorAll('a[href="#schornstein-konfigurator"]').forEach((link) => {
      if (link.dataset.configOpenReady) return;
      link.dataset.configOpenReady = "true";
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const requestedSystem = link.dataset.configSystem;
        if (requestedSystem && config.systems?.[requestedSystem]) {
          const radio = form.querySelector(`[name="system"][value="${requestedSystem}"]`);
          if (radio) radio.checked = true;
          selectSystem(requestedSystem);
          render();
          syncStepValidity();
        }
        setConfiguratorOpen(true);
        const nextStep = steps.findIndex((_, index) => !completedSteps.has(index));
        openAccordionStep(nextStep);
        document.querySelector("#schornstein-konfigurator")?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    const commitStep = (fieldset) => {
      const index = steps.indexOf(fieldset);
      if (index < 0 || index >= steps.length) return;
      render();
      syncStepValidity();
      if (!completedSteps.has(index)) {
        openAccordionStep(index);
        return;
      }
      let nextStep = steps.findIndex((_, stepIndex) => stepIndex > index && !completedSteps.has(stepIndex));
      if (nextStep === -1) nextStep = steps.findIndex((_, stepIndex) => !completedSteps.has(stepIndex));
      openAccordionStep(nextStep);
    };

    steps.forEach((fieldset, index) => {
      const legend = fieldset.querySelector("legend");
      legend?.addEventListener("click", () => {
        openAccordionStep(openStep === index ? -1 : index);
      });
      legend?.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openAccordionStep(openStep === index ? -1 : index);
        }
      });
    });

    const syncDiameters = (preferred = diameter.value) => {
      const requiredKeys = ["wall_base", "floor_base", "cleaning", "connector", "holder_50", "holder_150", "holder_250", "holder_360", "length_1000", "length_500", "length_250", "top_standard"];
      const requiredProducts = requiredKeys.map((key) => products[key]).filter(Boolean);
      const diameters = ["130", "150", "180", "200"].filter((value) =>
        requiredProducts.length === requiredKeys.length && requiredProducts.every((product) => variantFor(product, value)),
      );
      diameter.replaceChildren(...diameters.map((value) => new Option(`Ø ${value} mm`, value)));
      if (diameters.includes(preferred)) diameter.value = preferred;
      if (!diameters.length) diameter.add(new Option("Keine vollständige Varianten-Zuordnung", ""));
      return diameters;
    };
    syncDiameters("150");

    const selectSystem = (nextSystemKey) => {
      const previousDiameter = diameter.value;
      systemKey = config.systems?.[nextSystemKey] ? nextSystemKey : "dw_fu";
      systemConfig = config.systems?.[systemKey] || {};
      products = systemConfig.productsSource === "settings" ? config.products : (systemConfig.products || {});
      technicalDimensions = TECHNICAL_DIMENSIONS[systemKey] || {};
      syncDiameters(previousDiameter);
      originalComponentsIntro.textContent = `Original ${systemConfig.label || "Jeremias DW-FU"} Bauteile – passend zu Ihrer Konfiguration.`;
      compatibilityNote.hidden = !systemConfig.hybrid;
      root.dataset.systemKey = systemKey;
    };

    const addLine = (
      items,
      key,
      quantity,
      required,
      reason,
      selectedVariant = null,
      properties = {},
    ) => {
      if (!quantity) return;
      const product = products[key];
      const variant = selectedVariant || variantFor(product, diameter.value);
      items.push({
        key,
        product,
        variant,
        quantity,
        required,
        reason,
        properties,
      });
    };

    const wallPassageLength = (key) => {
      const match = String((systemConfig.wallPassageLengths || config.wallPassageLengths)?.[key] || "").match(
        /(500|1000)\s*mm/i,
      );
      return match ? Number(match[1]) : null;
    };

    const wallPassagePlan = (active) => {
      if (!active) return { active: false };
      const thicknessCm = Number(wallThickness.value);
      if (!Number.isFinite(thicknessCm) || thicknessCm <= 0) {
        return {
          active: true,
          error: "Bitte geben Sie eine gültige Wandstärke in cm ein.",
        };
      }
      const requiredMm = Math.ceil(thicknessCm * 10);
      const options = ["wall_passage_short", "wall_passage_long"]
        .map((key) => ({ key, lengthMm: wallPassageLength(key) }))
        .filter((option) => option.lengthMm)
        .sort((a, b) => a.lengthMm - b.lengthMm);
      if (options.length !== 2) {
        return {
          active: true,
          thicknessCm,
          requiredMm,
          error:
            "Die Standardlängen der Wanddurchführung sind nicht vollständig hinterlegt. Bitte lassen Sie die Ausführung von uns prüfen.",
        };
      }
      const selected = options.find((option) => requiredMm <= option.lengthMm);
      if (!selected) {
        return {
          active: true,
          thicknessCm,
          requiredMm,
          error:
            "Für diese Wandstärke ist keine passende Standard-Wanddurchführung hinterlegt. Bitte lassen Sie die Ausführung von uns prüfen.",
        };
      }
      return {
        active: true,
        thicknessCm,
        requiredMm,
        key: selected.key,
        lengthMm: selected.lengthMm,
        needsTrim: requiredMm < selected.lengthMm,
      };
    };

    const syncRoofSlopes = (product) => {
      const previous = roofSlope.value;
      const slopes = [
        ...new Set(
          (product?.variants || [])
            .filter((variant) => diameterOf(variant) === diameter.value)
            .map(roofSlopeOf)
            .filter(Boolean),
        ),
      ];
      roofSlope.replaceChildren(
        ...slopes.map((slope) => new Option(slope, slope)),
      );
      if (slopes.includes(previous)) roofSlope.value = previous;
      if (!slopes.length)
        roofSlope.add(new Option("Keine passende Dachneigung verfügbar", ""));
      return slopes;
    };

    const fixedHeightModel = (items) => {
      const components = items
        .filter((item) =>
          ["cleaning", "connector", "top_standard", "top_rain"].includes(item.key),
        )
        .map((item) => ({
          key: item.key,
          quantity: item.quantity,
          effective_vertical_height_mm: (() => {
            const value = technicalDimensions[item.key]?.effectiveHeightMm;
            return value && typeof value === "object" ? (value[diameter.value] ?? null) : (value ?? null);
          })(),
        }));
      return {
        components,
        missing: components
          .filter((component) => component.effective_vertical_height_mm === null)
          .map((component) => technicalDimensions[component.key]?.label || component.key),
        total: components.reduce(
          (sum, component) =>
            sum +
            (component.effective_vertical_height_mm || 0) * component.quantity,
          0,
        ),
      };
    };

    const lengthPlan = (remaining) => {
      const target = Math.max(0, Math.round(remaining));
      if (!target) return { items: [], totalEffectiveMm: 0, error: null };

      const fullLength = technicalDimensions.length_1000?.effectiveHeightMm;
      if (!fullLength) return { items: [], totalEffectiveMm: 0, error: "Für dieses System fehlt eine verifizierte wirksame Länge." };
      if (!systemConfig.shorteningAllowed) {
        const lengths = [
          ["length_1000", technicalDimensions.length_1000?.effectiveHeightMm],
          ["length_500", technicalDimensions.length_500?.effectiveHeightMm],
          ["length_250", technicalDimensions.length_250?.effectiveHeightMm],
        ].filter((entry) => entry[1]);
        let best = null;
        for (let a = 0; a <= Math.ceil(target / lengths[0][1]); a += 1) for (let b = 0; b <= 3; b += 1) for (let c = 0; c <= 4; c += 1) {
          const total = a * lengths[0][1] + b * lengths[1][1] + c * lengths[2][1];
          if (total === target) best = [[lengths[0][0], a, lengths[0][1]], [lengths[1][0], b, lengths[1][1]], [lengths[2][0], c, lengths[2][1]]];
        }
        if (!best) return { items: [], totalEffectiveMm: 0, error: "Die Zielhöhe ist ohne unbestätigtes Kürzen für dieses System nicht exakt erreichbar." };
        return { items: best.filter((entry) => entry[1]).map(([key, quantity, effectiveHeightMm]) => ({ key, quantity, effectiveHeightMm, cutRequired: false })), totalEffectiveMm: target, error: null };
      }
      const count = Math.ceil(target / fullLength);
      const cutEffectiveMm = target - (count - 1) * fullLength;
      if (cutEffectiveMm <= 0 || cutEffectiveMm > fullLength) {
        return {
          items: [],
          totalEffectiveMm: 0,
          error: "Die verbleibende gerade Höhe kann nicht sicher zusammengestellt werden.",
        };
      }

      const items = [];
      if (count > 1) {
        items.push({
          key: "length_1000",
          quantity: count - 1,
          effectiveHeightMm: fullLength,
          cutRequired: false,
        });
      }
      items.push({
        key: "length_1000",
        quantity: 1,
        effectiveHeightMm: cutEffectiveMm,
        cutRequired: cutEffectiveMm < fullLength,
        cutByMm: fullLength - cutEffectiveMm,
      });
      return { items, totalEffectiveMm: target, error: null };
    };

    const renderSketch = () => {
      const mounting = form.elements.mounting.value;
      const wallPassageActive = form.elements.wall_passage.value === "with";
      const roofActive = form.elements.roof_penetration.value === "with";
      const layerState = {
        diagram: true,
        "wall-console-short": mounting === "wall" && holder.value === "50",
        "wall-console-medium": mounting === "wall" && holder.value === "150",
        "wall-console-long": mounting === "wall" && ["250", "360"].includes(holder.value),
        "support-base": mounting === "floor",
        "cleanout-t": true,
        shaft: true,
        "offset-15": offset.checked && offsetAngle.value === "15",
        "offset-30": offset.checked && offsetAngle.value === "30",
        "offset-45": offset.checked && offsetAngle.value === "45",
        "wall-penetration": wallPassageActive,
        "connection-1": true,
        "connection-2": Number(form.elements.connector_quantity.value) === 2,
        "wall-holder-50": mounting === "wall" && holder.value === "50",
        "wall-holder-150": mounting === "wall" && holder.value === "150",
        "wall-holder-250": mounting === "wall" && holder.value === "250",
        "wall-holder-360": mounting === "wall" && holder.value === "360",
        "roof-penetration-tile": roofActive && roofing.value === "tile",
        "roof-penetration-slate": roofActive && roofing.value === "slate",
        bracing: brace.checked,
        "rain-cap": form.elements.top.value === "rain",
      };

      sketchLayers.forEach((layer) => {
        const visible = Boolean(layerState[layer.dataset.sketchLayer]);
        layer.classList.toggle("is-visible", visible);
        layer.setAttribute("aria-hidden", String(!visible));
      });
    };

    const render = () => {
      offsetOptions.hidden = !offset.checked;
      const wallPassageActive = form.elements.wall_passage.value === "with";
      wallOptions.hidden = !wallPassageActive;
      const wallPlan = wallPassagePlan(wallPassageActive);
      wallError.hidden = !wallPlan.error;
      wallError.textContent = wallPlan.error || "";
      const roofActive = form.elements.roof_penetration.value === "with";
      roofOptions.hidden = !roofActive;
      root
        .querySelectorAll(".msp-chimney-choice")
        .forEach((choice) =>
          choice.classList.toggle(
            "is-selected",
            Boolean(choice.querySelector("input:checked")),
          ),
      );
      const mounting = form.elements.mounting.value;
      const wallConsoleKey =
        holder.value === "360"
          ? "wall_console_360"
          : holder.value === "250"
            ? "wall_console_250"
            : "wall_console_150";
      const wallPassage = wallPassageActive;
      const roofProductKey =
        roofing.value === "tile"
          ? "roof_flashing_tile"
          : "roof_flashing_slate";
      const roofProduct = products[roofProductKey];
      syncRoofSlopes(roofProduct);
      const roofVariant = roofActive
        ? roofProduct?.variants?.find(
            (variant) =>
              diameterOf(variant) === diameter.value &&
              roofSlopeOf(variant) === roofSlope.value,
          ) || null
        : null;
      const roofMappingMissing = roofActive && (!roofProduct || !roofVariant);
      const top = form.elements.top.value;
      const items = [];
      const selectedConnectorQuantity = Number(
        form.elements.connector_quantity.value || 1,
      );
      if (mounting === "wall")
        addLine(
          items,
          wallConsoleKey,
          1,
          true,
          "Tragende Wandkonsole für den gewählten Wandabstand",
        );
      addLine(
        items,
        mounting === "wall" ? "wall_base" : "floor_base",
        1,
        true,
        mounting === "wall"
          ? "Basis für die Wandmontage"
          : "Basis für die Bodenmontage",
      );
      addLine(items, "cleaning", 1, true, "Für Reinigung und Kontrolle");
      addLine(
        items,
        "connector",
        selectedConnectorQuantity,
        true,
        systemKey === "dw_silver" ? "87° Anschluss zur Feuerstätte" : "90° waagerechter Anschluss zur Feuerstätte",
      );
      if (wallPassageActive && wallPlan.key)
        addLine(
          items,
          wallPlan.key,
          1,
          true,
          "Für die gewählte Wanddurchführung",
        );
      addLine(
        items,
        `holder_${holder.value}`,
        Math.max(1, Number(holderQuantity.value) || 1),
        true,
        "Zur Befestigung an der Außenwand",
      );
      if (roofActive)
        addLine(
          items,
          roofProductKey,
          1,
          true,
          "Für die gewählte Dacheindeckung und Dachneigung",
          roofVariant,
        );
      const topKey = top === "rain" ? "top_rain" : "top_standard";
      const silverRainAccessory = systemKey === "dw_silver" && top === "rain";
      const heightTopKey = silverRainAccessory ? "top_standard" : topKey;
      const heightModel = fixedHeightModel([
        ...items,
        { key: heightTopKey, quantity: 1 },
      ]);
      const targetHeight = Math.round((Number(height.value) || 5) * 1000);
      const remainingStraightLength = targetHeight - heightModel.total;
      const heightTooSmall = remainingStraightLength < 0;
      const planned = lengthPlan(Math.max(0, remainingStraightLength));
      planned.items.forEach((planItem) => {
        const reason = planItem.cutRequired
          ? `Vor Ort um ${planItem.cutByMm} mm passend zu kürzen`
          : `Wirksame Montagelänge ${planItem.effectiveHeightMm} mm`;
        addLine(items, planItem.key, planItem.quantity, true, reason, null, {
          "Erforderliche wirksame Länge": `${planItem.effectiveHeightMm} mm`,
          "Kürzen erforderlich": planItem.cutRequired ? "Ja" : "Nein",
          ...(planItem.cutRequired
            ? { "Kürzung vor Ort": `${planItem.cutByMm} mm` }
            : {}),
        });
      });
      if (offset.checked)
        addLine(
          items,
          `offset_${offsetAngle.value}`,
          Math.max(1, Number(offsetQuantity.value) || 1),
          false,
          "Für die gewählte Schrägführung",
        );
      if (brace.checked)
        addLine(items, "brace", 1, false, "Zusätzliche Abspannung");
      addLine(items, heightTopKey, 1, true, "Gewählter Schornsteinabschluss");
      if (silverRainAccessory)
        addLine(items, "top_rain", 1, false, "Optionale Regenhaube; nicht Teil der axialen Schornsteinhöhe");

      const summary = [
        ["System", systemConfig.label || "Jeremias DW-FU"],
        ["Durchmesser", diameter.value ? `Ø ${diameter.value} mm` : "–"],
        ["Gesamthöhe", `${Number(height.value).toLocaleString("de-DE")} m`],
        ["Montage", mounting === "wall" ? "Wandkonsole" : "Stützfuß"],
        ["Reinigung", "Mit Reinigungsöffnung"],
        ["Wanddurchführung", wallPassage ? "Ja" : "Nein"],
        ["Dachdurchführung", roofActive ? "Ja" : "Nein"],
        [
          "Wandabstand",
          `${holder.options[holder.selectedIndex].text} · ${Math.max(1, Number(holderQuantity.value) || 1)}×`,
        ],
        [
          "Versatz",
          offset.checked
            ? `${offsetAngle.value}° · ${Math.max(1, Number(offsetQuantity.value) || 1)} Bogen`
            : "Nein",
        ],
        ["Abspannung", brace.checked ? "Ja" : "Nein"],
        [
          "Abschluss",
          top === "rain" ? "Regenhaube mit Abschluss" : "Mündungsabschluss",
        ],
      ];
      summary.splice(
        5,
        0,
        [
          "Feuerstättenanschlüsse",
          `${selectedConnectorQuantity} × ${systemKey === "dw_silver" ? "87°" : "90° waagerecht"}`,
        ],
      );
      if (wallPlan.active && !wallPlan.error) {
        const wallItem = items.find((item) => item.key === wallPlan.key);
        if (wallItem) {
          wallItem.reason = `${wallPlan.lengthMm} mm · bei Bedarf vor Ort kürzbar · Wandfutter enthalten`;
          wallItem.properties = {
            Wandstärke: `${wallPlan.thicknessCm.toLocaleString("de-DE")} cm`,
            Wanddurchführung: `${wallPlan.lengthMm} mm`,
            "Kürzen erforderlich": wallPlan.needsTrim ? "Ja" : "Nein",
            "Wandfutter enthalten": "Ja",
          };
        }
      }
      facts.innerHTML = summary
        .map(([term, value]) => `<div><dt>${term}</dt><dd>${value}</dd></div>`)
        .join("");

      let sum = 0;
      let complete =
        Boolean(diameter.value) &&
        !wallPlan.error &&
        !heightTooSmall &&
        !heightModel.missing.length &&
        !planned.error &&
        !offset.checked;
      let available = true;
      cartItems = [];
      items.forEach((item) => {
          if (!item.product || !item.variant) {
            complete = false;
            return;
          }
          if (!item.variant.available) available = false;
          const linePrice = item.variant.price * item.quantity;
          sum += linePrice;
          cartItems.push({
            id: item.variant.id,
            quantity: item.quantity,
            properties: {
              ...item.properties,
              _Konfiguration: "Außenschornstein",
              _System: systemKey,
              _Durchmesser: `Ø ${diameter.value} mm`,
            },
          });
        });
      originalComponents.replaceChildren(
        ...items.map((item) => {
          const card = document.createElement("article");
          card.className = "msp-chimney-original-component";
          const image = item.product?.image
            ? `<img src="${item.product.image}" alt="" loading="lazy">`
            : "<span class=\"msp-chimney-original-component__missing\">Kein Originalbild</span>";
          const price = item.variant
            ? money(item.variant.price * item.quantity, config.moneyFormat)
            : "–";
          card.innerHTML = `<div class="msp-chimney-original-component__media">${image}</div><div><h4>${item.quantity} × ${item.product?.title || item.key.replaceAll("_", " ")}</h4><p>${item.reason}</p><strong>${price}</strong></div>`;
          return card;
        }),
      );
      total.textContent = complete
        ? money(sum, config.moneyFormat)
        : "Noch nicht vollständig";
      status.textContent = heightModel.missing.length
        ? `Für diese Konfiguration fehlt noch eine technische Maßangabe: die verifizierte wirksame Bauhöhe für ${heightModel.missing.join(", ")}.`
        : heightTooSmall
          ? "Die gewählte Gesamthöhe ist für diese Bauteilkombination zu gering."
          : planned.error
            ? planned.error
          : offset.checked
            ? "Konfigurationen mit Versatz bleiben gesperrt, bis die vertikale Projektion der Bögen und Zwischenlänge verifiziert ist."
          : wallPlan.error
        ? wallPlan.error
        : roofMappingMissing
        ? "Für diese Dachausführung ist derzeit keine passende Dachdurchführung zugeordnet."
        : !complete
          ? "Mindestens eine Produktzuordnung oder Durchmesser-Variante fehlt."
          : !available
            ? "Mindestens eine Variante ist derzeit nicht verfügbar."
            : `${cartItems.length} Positionen vollständig und verfügbar.`;
      cart.disabled = !complete || !available || !cartItems.length || adding;
      sketchCaption.textContent = `Außenschornstein · Ø ${diameter.value || "–"} mm · ${Number(height.value).toLocaleString("de-DE")} m`;
      renderSketch();
    };

    form.addEventListener("input", (event) => {
      if (event.target.matches('input[type="number"]')) render();
    });
    form.addEventListener("change", (event) => {
      if (event.target.matches('[name="system"]')) selectSystem(event.target.value);
      commitStep(event.target.closest("fieldset"));
    });
    form.addEventListener("click", (event) => {
      const label = event.target.closest("label");
      const radio = label?.querySelector('input[type="radio"]');
      if (radio?.checked && event.target !== radio) {
        commitStep(label.closest("fieldset"));
      }
    });
    root.querySelector("[data-height-minus]").addEventListener("click", () => {
      height.stepDown();
      commitStep(steps[2]);
    });
    root.querySelector("[data-height-plus]").addEventListener("click", () => {
      height.stepUp();
      commitStep(steps[2]);
    });
    cart.addEventListener("click", async () => {
      if (cart.disabled || adding) return;
      adding = true;
      cart.disabled = true;
      cart.textContent = "WIRD HINZUGEFÜGT …";
      status.textContent = "";
      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || "/"}cart/add.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ items: cartItems }),
          },
        );
        if (!response.ok) throw new Error("cart");
        await response.json();
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        status.textContent =
          "Die komplette Konfiguration wurde in den Warenkorb gelegt.";
        cart.textContent = "IM WARENKORB";
      } catch (_) {
        status.textContent =
          "Das Hinzufügen war gerade nicht möglich. Bitte erneut versuchen oder Beratung anfragen.";
        cart.textContent = "ERNEUT VERSUCHEN";
      } finally {
        adding = false;
        cart.disabled = false;
      }
    });
    selectSystem(systemKey);
    render();
    syncStepValidity();
    setConfiguratorOpen(window.location.hash === "#schornstein-konfigurator");
  };

  const boot = () =>
    document.querySelectorAll("[data-msp-chimney-config]").forEach(init);
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
